/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IRdaCustomHtmlViewProps } from './rda-custom-html';
import { SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { Module } from '@msdyn365-commerce-modules/utilities';

export default (props: IRdaCustomHtmlViewProps, data: any) => {
    const { RdaCustomHtml } = props;
    return (
        <Module {...RdaCustomHtml}>
            <div className='row'>
                {props.config.marketingProperties?.match('features') && _renderFeatures(props.data.product.result, props)}
                {props.config.marketingProperties?.match('description') && _renderDescription(props.data.product.result, props)}
                {props.config.marketingProperties?.match('specifications') && _renderSpecifications(props.data.product.result, props)}
                {props.config.marketingProperties?.match('additionalDescription') &&
                    _renderAdditionalDescription(props.data.product.result, props)}
            </div>
        </Module>
    );
};

const _renderFeatures = (product: SimpleProduct | undefined, props: IRdaCustomHtmlViewProps): JSX.Element => {
    let _showBlock = false;
    let _html: any = '';
    if (product !== undefined) {
        product.ExtensionProperties?.map(function(property) {
            if (property.Key === 'MarketingFeatures' && property.Value?.StringValue) {
                _showBlock = true;
                _html = property.Value?.StringValue;
            }
        });
    }
    return (
        <>
            {_showBlock && (
                <>
                    <h2>{props.config.heading !== '' ? props.config.heading : 'Features'}</h2>
                    <div className='ms-buybox__m-features' dangerouslySetInnerHTML={{ __html: _html }}></div>
                </>
            )}
        </>
    );
};

const _renderDescription = (product: SimpleProduct | undefined, props: IRdaCustomHtmlViewProps): JSX.Element => {
    let _showBlock = false;
    let _html: any = '';
    if (product !== undefined) {
        product.ExtensionProperties?.map(function(property) {
            if (property.Key === 'MarketingDescription' && property.Value?.StringValue) {
                _showBlock = true;
                _html = property.Value?.StringValue;
            }
        });
    }
    return (
        <>
            {_showBlock && (
                <>
                    <h2>{props.config.heading !== '' ? props.config.heading : 'Description'}</h2>
                    <div className='ms-buybox__m-features' dangerouslySetInnerHTML={{ __html: _html }}></div>
                </>
            )}
        </>
    );
};

const _renderSpecifications = (product: SimpleProduct | undefined, props: IRdaCustomHtmlViewProps): JSX.Element => {
    let _showBlock = false;
    let _html: any = '';
    if (product !== undefined) {
        product.ExtensionProperties?.map(function(property) {
            if (property.Key === 'MarketingSpecifications' && property.Value?.StringValue) {
                _showBlock = true;
                _html = property.Value?.StringValue;
            }
        });
    }
    return (
        <>
            {_showBlock && (
                <>
                    <h2>{props.config.heading !== '' ? props.config.heading : 'Specifications'}</h2>
                    <div className='ms-buybox__m-specifications' dangerouslySetInnerHTML={{ __html: _html }}></div>
                </>
            )}
        </>
    );
};

const _renderAdditionalDescription = (product: SimpleProduct | undefined, props: IRdaCustomHtmlViewProps): JSX.Element => {
    let _showBlock = false;
    let _html: any = '';
    if (product !== undefined) {
        product.ExtensionProperties?.map(function(property) {
            if (property.Key === 'MarketingAdditionalDescription' && property.Value?.StringValue) {
                _showBlock = true;
                _html = property.Value?.StringValue;
            }
        });
    }
    return (
        <>
            {_showBlock && (
                <>
                    <h2>{props.config.heading !== '' ? props.config.heading : 'Additional Features'}</h2>
                    <div className='ms-buybox__m-additional-features' dangerouslySetInnerHTML={{ __html: _html }}></div>
                </>
            )}
        </>
    );
};
